/**
 * Mirrors apps/api/src/app/staff/testing-account.ts — the api refuses to add a device outside the
 * OptiSigns Testing account with this exact message, and rows added before that gate existed show
 * it in the drawer instead of any actions. (No shared libs with the api; vendor by copy.)
 */
export const TESTING_DEVICE_REQUIRED_MESSAGE =
  'Please pair your testing device to OptiSigns Testing account';
